"use client";

import { FC } from "react";
import Link from "next/link";
import Typography from "@mui/material/Typography";

import { useStyles } from "./styles";
import PrimaryButton from "@/components/common/PrimaryButton";

interface NotFoundProps {
  title: string;
}

const NotFound: FC<NotFoundProps> = ({ title }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Typography variant="h1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="h2" color="secondary">
          404
        </Typography>
        <Link href="/">
          <PrimaryButton color="secondary" className={classes.button}>
            Go Home
          </PrimaryButton>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
